import { Budget, DietaryRestriction, Language } from "@garther/interfaces";

export const PREFERENCES = {
  budget: {
    label: "preferences.budget",
    options: [
      {
        label: "preferences.budgetOptions.cheap",
        value: Budget.CHEAP
      },
      {
        label: "preferences.budgetOptions.moderate",
        value: Budget.MODERATE
      },
      {
        label: "preferences.budgetOptions.expensive",
        value: Budget.EXPENSIVE
      }
    ]
  },
  languages: {
    label: "preferences.languages",
    options: [
      {
        label: "preferences.languageOptions.vietnamese",
        value: Language.VIETNAMESE
      },
      {
        label: "preferences.languageOptions.english",
        value: Language.ENGLISH
      }
    ]
  },
  dietaryRestrictions: {
    label: "preferences.dietaryRestrictions",
    options: [
      {
        label: "preferences.dietaryOptions.vegan",
        value: DietaryRestriction.VEGAN
      },
      {
        label: "preferences.dietaryOptions.vegetarian",
        value: DietaryRestriction.VEGETARIAN
      },
      {
        label: "preferences.dietaryOptions.glutenFree",
        value: DietaryRestriction.GLUTEN_FREE
      },
      {
        label: "preferences.dietaryOptions.halal",
        value: DietaryRestriction.HALAL
      },
      {
        label: "preferences.dietaryOptions.kosher",
        value: DietaryRestriction.KOSHER
      },
      {
        label: "preferences.dietaryOptions.other",
        value: DietaryRestriction.OTHER
      }
    ]
  }
};
